import { UNIT } from '../../constants/configuration';

const styles = {
  space: {
    padding: `${UNIT * 1.25}px 0px`
  }
};

export default styles;